import { motion } from "framer-motion";
import { Calendar, Bot, Clock, DollarSign, TrendingUp } from "lucide-react";
import { formatBRL } from "@/data/mockData";

const CARD_STYLES = {
  blue: { icon: "text-blue-600", bg: "bg-blue-50", ring: "ring-blue-100" },
  emerald: { icon: "text-emerald-600", bg: "bg-emerald-50", ring: "ring-emerald-100" },
  amber: { icon: "text-amber-600", bg: "bg-amber-50", ring: "ring-amber-100" },
  indigo: { icon: "text-indigo-600", bg: "bg-indigo-50", ring: "ring-indigo-100" },
};

const KpiCard = ({ card, index }) => {
  const s = CARD_STYLES[card.color];
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06, ease: "easeOut" }}
      data-testid={`kpi-${card.id}`}
      className="group relative overflow-hidden rounded-2xl border border-slate-200/70 bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.04)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,0,0,0.06)]"
    >
      <div className="flex items-start justify-between">
        <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${s.bg} ring-1 ${s.ring}`}>
          <card.icon className={`h-5 w-5 ${s.icon}`} strokeWidth={2.2} />
        </div>
        {card.trend && (
          <span className="flex items-center gap-1 rounded-full bg-slate-50 px-2 py-0.5 text-xs font-semibold text-slate-500">
            <TrendingUp className="h-3 w-3 text-emerald-500" />
            {card.trend}
          </span>
        )}
      </div>
      <div className="mt-4">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">
          {card.title}
        </p>
        <p
          data-testid={`kpi-${card.id}-value`}
          className="font-mono-num mt-1 text-2xl font-bold text-slate-900"
        >
          {card.value}
        </p>
        <p className="mt-0.5 text-xs text-slate-500">{card.subtitle}</p>
      </div>
    </motion.div>
  );
};

export const KpiGrid = ({ stats }) => {
  const cards = [
    {
      id: "total-consultas",
      title: "Total de Consultas",
      icon: Calendar,
      color: "blue",
      value: stats.total,
      subtitle: `${stats.remaining} restantes hoje`,
    },
    {
      id: "confirmadas-ia",
      title: "Confirmadas por IA",
      icon: Bot,
      color: "emerald",
      value: stats.confirmed,
      subtitle: `${stats.confirmRate}% de taxa de sucesso`,
      trend: `${stats.confirmRate}%`,
    },
    {
      id: "aguardando-recepcao",
      title: "Aguardando na Recepção",
      icon: Clock,
      color: "amber",
      value: stats.waiting,
      subtitle: stats.waiting === 1 ? "1 paciente presente" : `${stats.waiting} pacientes presentes`,
    },
    {
      id: "faturamento-dia",
      title: "Faturamento do Dia",
      icon: DollarSign,
      color: "indigo",
      value: formatBRL(stats.revenue),
      subtitle: `${stats.paidCount} pagamentos registrados`,
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {cards.map((c, i) => (
        <KpiCard key={c.id} card={c} index={i} />
      ))}
    </div>
  );
};
